import {Component, Input} from '@angular/core';
import {EnvironmentService} from '../../core/services/environment.service';

@Component({
  selector: 'assessment-result',
  templateUrl: './assessment-result.component.html'
})
export class AssessmentResultComponent {

  @Input()
  subTitle!: string;
  @Input()
  subDesc!: string;
  @Input()
  imageName!: string;

  constructor(private environmentService: EnvironmentService) {
  }

  get assetsUrl(): string {
    return this.environmentService.assetsUrl + '/' + this.imageName;
  }
}
